import Settings from '@/views/Settings/Settings.vue';

const SettingsRoutes = [
    {
        path: "/settings",
        name: "Settings",
        meta: {
            requiresAuth: true,
            requiresAdmin: true
        },
        components: {
            page: Settings
        }
    }
];

export default SettingsRoutes;
